import BaseInput from "../../../baseComponents/baseInput.js";
import BaseButton from "../../../baseComponents/baseButton.js";
import { useEffect, useState } from "react";
import LoginTemplate from "../LoginTemplate.js";
import { asyncActions as loginAsyncActions } from "../../../store/slices/loginSlice.js";
import { useDispatch, useSelector } from "react-redux";
import Coder from "../../../components/Coder.js";
import useColors from "../../../customHooks/useColors.js";
import { useSearchParams } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import BaseParagraph from "../../../baseComponents/baseParagraph.js";

const ForgotPasswordView = ({
  title,
  autoRelogin = true,
  afterLoginRoutesPath = [],
}) => {
  const [currentColors] = useColors();
  /////////////////////////////////////////////////////////////////////////////////////////////dispatcher, navigator
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /////////////////////////////////////////////////////////////////////////////////////////////redux states

  /////////////////////////////////////////////////////////////////////////////////////////////local states
  const [errorMsg, setErrorMsg] = useState("");
  const [requestSent, setRequestSent] = useState(false);
  const [tokenInput, setTokenInput] = useState("");
  const [tokenInputFull, setTokenInputFull] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [confirmPasswordInput, setConfirmPasswordInput] = useState("");

  /////////////////////////////////////////////////////////////////////////////////////////////handling inputs

  const handlePasswordInput = (e) => {
    clearError();
    setPasswordInput(e.target.value);
  };

  const handleConfirmPasswordInput = (e) => {
    clearError();
    setConfirmPasswordInput(e.target.value);
  };

  /////////////////////////////////////////////////////////////////////////////////////////////styles
  const styles = {
    button: {
      paddingLeft: "1em",
      paddingRight: "1em",
      paddingTop: "0.5em",
      paddingBottom: "0.5em",
    },
  };

  /////////////////////////////////////////////////////////////////////////////////////////////params
  const [searchParams, setSearchParams] = useSearchParams();
  const mobile = decodeURIComponent(searchParams.get("mobile"));


  /////////////////////////////////////////////////////////////////////////////////////////////methods
  const clearError = () => {
    setErrorMsg("");
    return true;
  };

  const navigateToRoot = () => {
    navigate("/");
    return true;
  };

  const requestMobilePasswordChange = async () => {
    clearError();

    if (tokenInputFull === false)  {
      return false;
    }

    const res = await dispatch(
      loginAsyncActions.changePassword({
        pMethod: "S",
        pUserIdentifier: mobile,
        pToken: tokenInput,
        password: passwordInput,
        confirmPassword: confirmPasswordInput,
        navigate: navigate,
        setErrorMsg: setErrorMsg,
      })
    );
  };

  /////////////////////////////////////////////////////////////////////////////////////////////effects

  /////////////////////////////////////////////////////////////////////////////////////////////render

  return (
    <LoginTemplate
      heading={title}
      autoRelogin={autoRelogin}
      onEnter={() => requestMobilePasswordChange()}
      success={""}
      afterLoginRoutesPath={afterLoginRoutesPath}
    >
      {!requestSent && (
        <>
         
          <BaseParagraph
            style={{
              color: currentColors.quaternary,
              fontSize: "19px",
            }}
          >
            token
          </BaseParagraph>
          <Coder
            stateSetter={setTokenInput}
            fullCodeStateSetter={setTokenInputFull}
          />
          <BaseInput
            type="password"
            placeholder="password"
            value={passwordInput}
            onChange={handlePasswordInput}
          />
          <BaseInput
            type="password"
            placeholder="repeatNewPassword"
            value={confirmPasswordInput}
            onChange={handleConfirmPasswordInput}
          />
          <BaseButton
            error={errorMsg}
            onClick={() => {
              requestMobilePasswordChange();
            }}
            disabled = {tokenInputFull === false}
          >
            save
          </BaseButton>
        </>
      )}
      <BaseButton style={styles.button} onClick={navigateToRoot}>
        homePage
      </BaseButton>
    </LoginTemplate>
  );
};

export default ForgotPasswordView;

//forgotPasswordTitle
